<template>
  <div class="card shadow-lg rounded-3 py-3" style="border:none">
    <div class="card-body p-1">
      <h1 class="card-title mb-3 text-dark text-uppercase" style="font-weight:700"><span
          style="color: #0092f7">Log</span> In</h1>
      <div class="container mb-2">
        <div class="row d-flex justify-content-center">
          <label>
            <input class="input-amount" ref="passwordField" @keyup.enter="login" placeholder="Enter your PIN" :type="passwordFieldType" v-model="password">
          </label>

          <label class="show-password-checkbox">
            <input type="checkbox" v-model="show_password">
            Show PIN
          </label>

          <br><br>
          <div class="container button-pane">
            <div class="row text-center d-flex flex-column align-items-center">
              <div class="col-12 d-inline-flex justify-content-center">
                <button @click="inputNumber($event)" class="btn" type="button">1</button>
                <button @click="inputNumber($event)" class="btn" type="button">2</button>
                <button @click="inputNumber($event)" class="btn" type="button">3</button>
              </div>
              <div class="col-12 d-inline-flex justify-content-center">
                <button @click="inputNumber($event)" class="btn" type="button">4</button>
                <button @click="inputNumber($event)" class="btn" type="button">5</button>
                <button @click="inputNumber($event)" class="btn" type="button">6</button>
              </div>
              <div class="col-12 d-inline-flex justify-content-center">
                <button @click="inputNumber($event)" class="btn" type="button">7</button>
                <button @click="inputNumber($event)" class="btn" type="button">8</button>
                <button @click="inputNumber($event)" class="btn" type="button">9</button>
              </div>
              <div class="col-12 d-inline-flex justify-content-center">
                <button @click="addPoint" class="btn" type="button">
                  .
                </button>
                <button @click="inputNumber($event)" class="btn" type="button">0</button>
                <button @click="backspace" class="btn" type="button">
                  <font-awesome-icon icon="fa-solid fa-delete-left"/>
                </button>
              </div>
            </div>
          </div>

          <div class="text-center my-3">
            <button :disabled="loading" @click="login" type="submit" class="login-btn">
              <span v-if="loading" class="spinner-grow spinner-grow-sm" role="status" aria-hidden="true"></span>
              Login
            </button>
            <p class="mt-2" style="margin: 0; padding: 0;"><a href="#" class="link-opacity-100-hover" @click.prevent="resetPassword">Forgot PIN?</a></p>
          </div>
          <!-- <p style="margin: 0; padding: 0; cursor: pointer">Click for classic version <a class="link-opacity-100-hover" @click="classicOld">Classic Version</a></p> -->

        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {responses} from "@/utils/responses";
import {Storage} from "@/services/Storage";

export default {
  name: "PosLoginForm",
  data() {
    return {
      password: '',
      loading: false,
      show_password: false
    }
  },
  async beforeMount() {
    if (!this.$store.getters.isHydrated) {
      await new Promise((resolve) => {
        const interval = setInterval(() => {
          if (store.getters.isHydrated) {
            clearInterval(interval);
            resolve();
          }
        }, 50);  // Check every 50ms
      });
    }
    const defaultStore = await Storage.getDefaultStore();
    if (defaultStore === null) {
      return this.$router.push({ name: 'login' });
    }
    this.$store.commit(`setReadyOrdersCount` , 0);
    let hasUsers = await auth.hasUsers()
    if (!hasUsers) {
      try {
        await this.$store.dispatch(`getAllUsers`)
      }catch (e) {}
    }
    await new Promise(resolve => setTimeout(resolve, 500));
    if (!androidMode){
      this.$refs.passwordField.focus();
    }
  },
  computed: {
    passwordFieldType() {
      return this.show_password ? 'text' : 'password';
    },
  },
  methods: {
    async classicOld(){
      return  window.open('https://lyt-classic.pos.co.zm/','_self');;
    },
    login() {
      this.loading = true;
      return this.$store.dispatch(`posLogin`, this.password)
          .then((res) => {
            if (!res.isValid) return responses.throwErr(`Incorrect Password`)
            if (res.username === 'Admin') {
              return this.$router.push({name: 'SelectUserView'})
            }
            this.$store.dispatch(`recordlogin`, res.username)
            return this.$router.push({name: 'float'})
          })
          .finally(() => this.loading = false)
    },
    async resetPassword() {
      let showingLoader = false;
      try {
        const { value: email } = await Swal.fire({
          title: 'Reset PIN',
          input: 'email',
          inputLabel: 'Enter your account email',
          inputPlaceholder: 'name@example.com',
          confirmButtonText: 'Send Reset',
          showCancelButton: true,
          inputAttributes: { autocapitalize: 'off', autocorrect: 'off' },
          inputValidator: (value) => {
            if (!value) return 'Email is required';
            const re = /[^@\s]+@[^@\s]+\.[^@\s]+/;
            if (!re.test(value)) return 'Enter a valid email address';
            return undefined;
          }
        });
        if (!email) return;

        const storeDB = await Storage.getCurrentStoreDB();
        if (!storeDB) return responses.throwErr('No store selected. Please configure a store first.');

        const localid = generateUUID();
        const url = `${backOfficeTomcatApi}auth/${storeDB}`;
        const payload = { localid, email };

        Swal.fire({ title: 'Sending...', allowOutsideClick: false, didOpen: () => Swal.showLoading() });
        showingLoader = true;

        const response = await axios.post(url, payload);
        const { data, status } = response || {};
        if (typeof status === 'number' && status >= 400) {
          const serverMsg = data && (data.message || data.msg || data.error);
          const err = new Error(serverMsg || `Request failed with status ${status}`);
          err.response = response;
          throw err;
        }

        const msg = (data && (data.message || data.msg)) ? (data.message || data.msg) : 'If the email exists, a reset instruction has been sent.';
        await Swal.fire({ icon: 'success', title: 'Request Sent', text: msg });
      } catch (err) {
        try { if (showingLoader) Swal.close(); } catch(e){}

        const status = err && err.response && err.response.status;
        const d = err && err.response && err.response.data;
        const serverMsg = d && (d.message || d.msg || d.error || d.detail);
        const baseMsg = serverMsg || (status === 403 ? 'You are not authorized to perform this action. Please verify your email and try again.' : 'Failed to send reset request');

        try { await Swal.fire({ icon: 'error', title: 'Request Failed', text: baseMsg }); } catch(e){}
        try { errorHandler(err, baseMsg); } catch(e){}
      } finally {
        try { if (showingLoader) Swal.close(); } catch(e){}
      }
    },

    // login() {
    //   this.loading = true;
    //   return this.$store.dispatch(`posLogin`, this.password)
    //       .then((res) => {
    //         if (!res) return responses.throwErr(`Incorrect Password`)
    //         return this.$router.push({name: 'float'})
    //
    //       })
    //       .finally(() => this.loading = false)
    // },
    inputNumber(event) {
      let elem = event.target
      if (elem) {
        let txt = elem.textContent || elem.innerText;
        if (txt) this.password += txt;
      }
    },
    addPoint() {
      if (!this.password.includes('.') && this.password !== '0') {
        this.password += '.'
      }
    },
    backspace() {
      let password = this.password
      let l = password.length
      this.password = password.substring(0, l - 1);
      l = this.password.length
      if (l === 0) {
        this.password = ''
      }
    },
  }
}
</script>

<style lang="scss" scoped>
.login-btn {
  background: #1e88e5;
  color: white;
  font-weight: 600;
  display: block;
  width: 100%;
  height: 45px;
}

.btn {
  display: inline-block;
  font-weight: 700;
  font-family: 'Inter', sans-serif;
  font-size: 25px;
  color: #212529;
  text-align: center;
  vertical-align: middle;
  cursor: pointer;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  background-color: transparent;
  border: 1px solid transparent;
  padding: .375rem .75rem;
  line-height: 1.5;
  border-radius: .25rem;
  transition: color .15s ease-in-out, background-color .15s ease-in-out, border-color .15s ease-in-out, box-shadow .15s ease-in-out;
}

button {
  border-radius: 10px !important;
  border: 1px solid #9e9e9e !important;
  height: 45px;
  width: 100px;
  outline: none;
  margin: 1px;
  box-shadow: -2px -2px 5px white, 3px 3px 5px rgb(0 0 0 / 10%);
}

.card {
  padding-left: 10px;
  padding-right: 10px;
  width: 400px;
  max-width: 95vw;
  margin-top: 3rem !important;
}

.show-password-checkbox {
  margin-bottom: 20px;
}

.input-amount {
  width: 100%;
  position: relative;
  display: block;
  margin: 0 auto;
  max-width: 350px;
  height: 35px;
  border-radius: 10px;
  border: none;
  outline: transparent;
  text-align: center;
  font-size: 25px;
  font-weight: 600;
  color: #363636;
}


</style>
